import type { CreateNodePromptContractConfig } from '../../entities/ai-assist-config';
import { USER_PROMPT_PLACEHOLDER } from '../../entities/ai-assist-config';
import type { NodeType } from '../../entities/node';
import { getAllowedAINodeFields } from './ai-node-field-validation';

const CREATE_NODE_TYPES: NodeType[] = ['Human', 'Project', 'Occupation'];

export function renderCreateNodePromptPreview(input: {
  promptContract: CreateNodePromptContractConfig;
  userPromptText?: string;
}): string {
  const userPromptText = input.userPromptText?.trim() ?? '';
  const basePrompt = input.promptContract.systemPromptTemplate.includes(USER_PROMPT_PLACEHOLDER)
    ? input.promptContract.systemPromptTemplate.replace(USER_PROMPT_PLACEHOLDER, userPromptText)
    : userPromptText
      ? `${input.promptContract.systemPromptTemplate}\n\nUser request:\n${userPromptText}`
      : input.promptContract.systemPromptTemplate;

  return [
    basePrompt.trim(),
    `Input description:\n${input.promptContract.inputDescription}`,
    [
      'Output contract:',
      input.promptContract.outputDescription,
      '- Return exactly one top-level JSON object.',
      '- Omit nodeId for create-node JSON.',
      '- Include nodeType as Human, Project, or Occupation.',
      '- Include displayName as a non-empty string.',
      '- Include only fields allowed for the chosen nodeType.',
      '- Relation arrays may use existing node ids or exact unique display names.',
    ].join('\n'),
    [
      'Allowed fields by nodeType:',
      ...CREATE_NODE_TYPES.map((nodeType) => `- ${nodeType}: ${getAllowedAINodeFields(nodeType).join(', ')}`),
      '- customFields entries must include fieldId, label, value, valueType, and displayOrder.',
    ].join('\n'),
    `Example JSON payload:\n${JSON.stringify(input.promptContract.examplePayload, null, 2)}`,
  ].join('\n\n');
}